import { useEffect, useState } from "react";

import { withNamespaces } from "react-i18next";

import { AuthContextValue } from "../../context/AuthContext";
import { GetContextValue } from "../../context/GetContext";
import Loading from "../../components/Loading/Loading";
import useFetch from "../../hooks/UseFetch";
import StandartTable from "../../components/Table/StandartTable/StandartTable";
import ErrorComponent from "../../components/ErrorComponent/ErrorComponent";

function TendersWaitingForOffer({ t, tableFilter, searchText, tableRender }) {
  const { token, loginUserCompanyId } = AuthContextValue();
  const {
    selectValueId,
    setSelectValueId,
    selectValue,
    setSelectValue,
    notificationRender,
  } = GetContextValue();

  const [
    opportunitiesWaitingForOfferPage,
    setOpportunitiesWaitingForOfferPage,
  ] = useState(1);
  const [
    opportunitiesWaitingForOfferRowsPerPage,
    setOpportunitiesWaitingForOfferRowsPerPage,
  ] = useState(10);

  const opportunitiesStatus = 2;

  const {
    setUseFetchRender: setOpportunitiesWaitingForOfferUseFetchRender,
    useFetchRender: opportunitiesWaitingForOfferUseFetchRender,
    error: opportunitiesWaitingForOfferError,
    loading: opportunitiesWaitingForOfferLoading,
    data: opportunitiesWaitingForOffer,
    total: opportunitiesWaitingForOfferTotal,
  } = useFetch(
    `${process.env.REACT_APP_GET_TENDER_SUPPLIER_LIST_URL}?Count=0&SortType=${tableFilter}&Status=${opportunitiesStatus}&CompanyId=${loginUserCompanyId}&Page=${opportunitiesWaitingForOfferPage}&PageSize=${opportunitiesWaitingForOfferRowsPerPage}`,
    token
  );
  const columns = [
    {
      key: "logo",
      header: t("table_photo"),
    },
    {
      key: "companyName",
      header: t("table_company_name"),
    },
    {
      key: "categories",
      header: t("table_category"),
    },
    {
      key: "productName",
      header: t("table_product"),
    },
    {
      key: "amount",
      header: t("table_amount"),
    },
    {
      key: "distance",
      header: t("table_distance"),
    },
    {
      key: "duration",
      header: t("table_duration"),
    },
    {
      key: "createdAt",
      header: t("table_create_date"),
    },
    {
      key: "remainingTime",
      header: t("table_remaining_time"),
    },
  ];

  useEffect(() => {
    setOpportunitiesWaitingForOfferUseFetchRender(
      !opportunitiesWaitingForOfferUseFetchRender
    );
  }, [tableRender, notificationRender]);

  /* sayfaya girdiğimizde contextte var olan veriyi siler */
  useEffect(() => {
    setSelectValue(null);
    setSelectValueId(null);
  }, []);

  function handleClickValue(valueId, value) {
    setSelectValueId(valueId);
    setSelectValue(value);
  }

  return (
    <>
      {opportunitiesWaitingForOfferError ? (
        <ErrorComponent error={opportunitiesWaitingForOfferError} />
      ) : opportunitiesWaitingForOfferLoading ? (
        <Loading />
      ) : opportunitiesWaitingForOffer !== null &&
        opportunitiesWaitingForOffer.length > 0 ? (
        <StandartTable
          type="tender"
          selectValueId={selectValueId}
          selectValue={selectValue}
          handleClickValue={handleClickValue}
          useFetchRender={opportunitiesWaitingForOfferUseFetchRender}
          setUseFetchRender={setOpportunitiesWaitingForOfferUseFetchRender}
          total={opportunitiesWaitingForOfferTotal}
          page={opportunitiesWaitingForOfferPage}
          setPage={setOpportunitiesWaitingForOfferPage}
          rowsPerPage={opportunitiesWaitingForOfferRowsPerPage}
          setRowsPerPage={setOpportunitiesWaitingForOfferRowsPerPage}
          columns={columns}
          data={opportunitiesWaitingForOffer}
        />
      ) : (
        <div className="table-null-text">{t("message_no_waiting_offer_opportunities")}</div>
      )}
    </>
  );
}

export default withNamespaces()(TendersWaitingForOffer);
